module.exports = __webpack_public_path__ + "static/media/normalRiskBg.2d8bac28.png";